import { render, staticRenderFns } from "./Estados.vue?vue&type=template&id=0731c042&scoped=true"
import script from "./Estados.vue?vue&type=script&lang=js"
export * from "./Estados.vue?vue&type=script&lang=js"
import style0 from "./Estados.vue?vue&type=style&index=0&id=0731c042&prod&lang=css"
import style1 from "./Estados.vue?vue&type=style&index=1&id=0731c042&prod&scoped=true&lang=css"
import style2 from "./styles.scss?vue&type=style&index=2&id=0731c042&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0731c042",
  null
  
)

export default component.exports